import React, { useState } from 'react';
import { SERVICES } from '../../data/siteData';
import SectionHeader from '../common/SectionHeader';
import AcademyModal from '../common/AcademyModal';

const SERVICE_ICONS = {
  'investment-advisory': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/>
      <polyline points="1 20 23 20"/>
    </svg>
  ),
  'asset-management': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <path d="M12 8v4l3 3"/>
    </svg>
  ),
  'crypto': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 7H6a2 2 0 00-2 2v9a2 2 0 002 2h9a2 2 0 002-2v-3"/>
      <path d="M14 2h5v5M19 2L9 12"/>
    </svg>
  ),
  'stocks': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
      <polyline points="16 7 22 7 22 13"/>
    </svg>
  ),
  'venture-capital': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  ),
  'academy': (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
      <path d="M6 12v5c3 3 9 3 12 0v-5"/>
    </svg>
  ),
};

function ServiceCard({ service, onEnroll }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: '36px 32px',
        background: hovered ? 'rgba(201,168,76,0.07)' : 'rgba(255,255,255,0.02)',
        border: '1px solid',
        borderColor: hovered ? 'rgba(201,168,76,0.4)' : 'rgba(201,168,76,0.1)',
        borderRadius: 'var(--radius-md)',
        transition: 'all 0.25s ease',
        display: 'flex', flexDirection: 'column', gap: '16px',
        boxShadow: hovered ? '0 8px 32px rgba(201,168,76,0.15), 0 0 0 1px rgba(201,168,76,0.1)' : 'none',
      }}
    >
      {/* Icon */}
      <div style={{
        width: '52px', height: '52px',
        background: 'rgba(201,168,76,0.1)',
        borderRadius: '10px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: hovered ? '0 0 20px rgba(201,168,76,0.3)' : 'none',
        transition: 'box-shadow 0.25s ease',
      }}>
        {SERVICE_ICONS[service.id]}
      </div>

      <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '22px', fontWeight: 600, color: 'var(--text-primary)' }}>
        {service.title}
      </h3>

      <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 1.75, fontWeight: 300 }}>
        {service.short}
      </p>

      <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
        {service.features.map((f, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px', color: 'var(--text-secondary)' }}>
            <span style={{ width: '18px', height: '1px', background: 'var(--gold)', flexShrink: 0 }} />
            {f}
          </li>
        ))}
      </ul>

      {/* Academy enroll button */}
      {service.hasEnrollment && (
        <button
          onClick={onEnroll}
          style={{
            marginTop: '8px',
            background: 'var(--gold)', color: 'var(--ink)',
            border: 'none', borderRadius: '4px',
            padding: '12px 20px', width: '100%',
            fontSize: '13px', fontWeight: 500,
            cursor: 'pointer', fontFamily: 'var(--font-sans)',
            letterSpacing: '0.05em',
            transition: 'background 0.2s',
          }}
          onMouseEnter={e => e.target.style.background = '#E8C97A'}
          onMouseLeave={e => e.target.style.background = 'var(--gold)'}
        >
          🎓 Enroll Now
        </button>
      )}
    </div>
  );
}

export default function ServicesSection() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section id="services" className="section" style={{ background: 'var(--ink)' }}>
      <div className="container">
        <SectionHeader
          tag="What We Offer"
          title='Comprehensive <em style="color:var(--gold);font-style:normal">Financial</em> Solutions'
        />
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '24px',
        }}>
          {SERVICES.map(service => (
            <ServiceCard
              key={service.id}
              service={service}
              onEnroll={() => setModalOpen(true)}
            />
          ))}
        </div>
      </div>

      <AcademyModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </section>
  );
}
